import { render, staticRenderFns } from "./_category-analysis.vue?vue&type=template&id=9006f290&scoped=true&"
import script from "./_category-analysis.vue?vue&type=script&lang=js&"
export * from "./_category-analysis.vue?vue&type=script&lang=js&"
import style0 from "./_category-analysis.vue?vue&type=style&index=0&id=9006f290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9006f290",
  null
  
)

export default component.exports